import { useEffect, useState } from 'react'
import { images } from '../../assets'
import styles from '../../assets/styles/PromotionPage.module.scss'

const APPLY_URL = 'https://r.spge.kr/apply/udh7llot'
const KAKAO_URL = 'http://pf.kakao.com/_Jjlxoxj/chat'

const PRICE_ROWS = [
  { reviews: '~ 30개', normal: '10,000원', badge: '⬇️ 1,000원' },
  { reviews: '31 ~ 60개', normal: '20,000원', badge: '⬇️ 11,000원' },
  { reviews: '61 ~ 120개', normal: '30,000원', badge: '⬇️ 21,000원' },
  { reviews: '121 ~ 300개', normal: '40,000원', badge: '⬇️ 31,000원' },
  { reviews: '301 ~ 450개', normal: '50,000원', badge: '⬇️ 41,000원' },
  { reviews: '451개 이상', normal: '60,000원', badge: '🔥 최대 51,000원 절약 ', max: true }
]

export const PromotionPage = () => {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80)

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className={styles.promotion}>
      <div className={`${styles.topLogo} ${scrolled ? styles.hidden : ''}`}>
        <img src={images.logoWhite} alt="스폰지 로고" />
      </div>

      <nav className={`${styles.gnb} ${scrolled ? styles.visible : ''}`}>
        <img src={images.logoBlue} alt="스폰지 로고" />
      </nav>

      <header className={styles.header}>
        <div className={styles.headerInner}>
          <p className={styles.headerTitle}>사장님,</p>
          <p className={styles.headerTitle}>
            댓글 관리에서 <br className={styles.brMobile} />
            해방시켜 드립니다
          </p>
          <p className={styles.headerSub}>지금부터 스폰지R과 함께하세요!</p>
        </div>
        <div className={styles.headerBtnWrap}>
          <a href={APPLY_URL} target="_blank" rel="noreferrer" className={`${styles.btnApply} ${styles.btnApplyHeader}`}>
            프로모션 신청하기
          </a>
        </div>
      </header>

      {/* 헤더 아래 히어로 섹션 */}
      <div className={styles.heroSection}>
        <p className={styles.subCopy}>고객과의 소통은 저희에게 맡기시고</p>
        <h2 className={styles.mainCopy}>사장님은 장사에만 집중하세요!</h2>
        <div className={styles.appBadges}>
          <div className={`${styles.appIconBadge} ${styles.imgBadge}`}>
            <img src={images.logoBaemin} alt="배민" />
          </div>
          <div className={`${styles.appIconBadge} ${styles.imgBadge}`}>
            <img src={images.logoYogiyo} alt="요기요" />
          </div>
          <div className={`${styles.appIconBadge} ${styles.imgBadge}`}>
            <img src={images.logoCoupang} alt="쿠팡이츠" />
          </div>
        </div>
      </div>

      <div className={styles.container}>
        {/* 프로모션 혜택 영역 */}
        <div className={styles.section}>
          <div className={styles.promoWrap}>
            <div className={styles.promoBadge}>🚨 선착순 마감 임박</div>
            <div className={styles.promoSubtitle}>
              지금 가입 시 최대 <strong>2개월 무료체험</strong>
            </div>
            <h3 className={styles.promoTitle}>
              선착순 <span>100개 매장</span>
              <br />
              한정 특별 프로모션
            </h3>

            <p className={styles.promoHighlightText}>
              무료체험이 끝나도 배달 리뷰 개수 상관없이
              <br />
              <span className={styles.superStrikeText}> 평생 월 9,000원 고정!</span>
            </p>

            {/* 원본 디자인의 구간 구성을 그대로 유지한 테이블 */}
            <div className={styles.priceCard}>
              <table className={styles.priceTable}>
                <thead>
                  <tr>
                    <th>월 리뷰 개수</th>
                    <th>기존 정상가</th>
                    <th>프로모션 초특가</th>
                  </tr>
                </thead>
                <tbody>
                  {PRICE_ROWS.map(row => (
                    <tr key={row.reviews} className={row.max ? styles.maxBenefitRow : ''}>
                      <td>{row.reviews}</td>
                      <td className={styles.strike}>{row.normal}</td>
                      <td className={styles.specialPriceCell}>
                        <span className={styles.priceHighlight}>
                          9,000원<span className={styles.discountBadge}>{row.badge}</span>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <span className={styles.vatNotice}>* 모든 구간은 부가세 별도 가격입니다.</span>
            <p className={styles.promoNote}>🎉 리뷰가 많이 쌓여도 가격 변동 없는 압도적인 혜택을 지금 체험하세요!</p>
          </div>
        </div>

        {/* 스폰지R 서비스 핵심 내용 */}
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>
            <span className={styles.titleLead}>
              <img src={images.logoBlue} alt="스폰지 로고" />이 사장님의
            </span>
            <span className={styles.titleTail}>
              <span className={styles.textMarker}>든든한 파트너</span>인 이유
            </span>
          </h2>

          <div className={styles.featureItem}>
            <div className={`${styles.featureIconBox} ${styles.iconBlue}`}>💬</div>
            <div className={styles.featureContent}>
              <h3>꼼꼼하고 정성스러운 맞춤 답글</h3>
              <p>
                복사+붙여넣기식 기계적인 답변은 그만! 고객이 남겨주신 소중한 리뷰의 내용을 꼼꼼히 파악하여, 매장의 긍정적인 이미지를 높이는 정성스러운
                맞춤형 답글을 작성해 드립니다.
              </p>
            </div>
          </div>

          <div className={styles.featureItem}>
            <div className={`${styles.featureIconBox} ${styles.iconRed}`}>🚨</div>
            <div className={styles.featureContent}>
              <h3>악성 리뷰 즉각 대처 및 알림</h3>
              <p>매장의 평점을 깎아먹는 악의적인 리뷰나 불만 사항이 등록될 경우, 사장님께 즉시 공유하여 발 빠르게 대처할 수 있도록 돕습니다.</p>
            </div>
          </div>

          <div className={styles.featureItem}>
            <div className={`${styles.featureIconBox} ${styles.iconGreen}`}>📊</div>
            <div className={styles.featureContent}>
              <h3>매월 제공되는 리뷰 분석 리포트</h3>
              <p>
                단순히 답글만 다는 것을 넘어, 월간 배달앱 리뷰 동향, 평점 변화, 고객 불만 키워드 등을 분석한 리포트를 제공하여 매장 운영 개선에 도움을
                드립니다.
              </p>
            </div>
          </div>

          <div className={styles.featureItem}>
            <div className={`${styles.featureIconBox} ${styles.iconYellow}`}>📱</div>
            <div className={styles.featureContent}>
              <h3>스폰지 사장님 전용 앱 제공</h3>
              <p>여러 배달앱에 흩어져 있는 리뷰를 하나의 앱에서 편하게 모아보고 관리할 수 있습니다. (구글 플레이, 앱스토어 다운로드 지원)</p>
            </div>
          </div>
        </div>
      </div>

      {/* 하단 CTA 영역 */}
      <div className={styles.applySection}>
        <div className={styles.applyBox}>
          <h3 className={styles.applyTitle}>
            스트레스 받는 <span className={styles.textPoint}>배달앱 리뷰 관리</span>, <br className={styles.brMobile} />
            이제 끝내세요!
          </h3>
          <p className={styles.applyDesc}>
            <span className={styles.priceHighlight}>월 9,000원</span>이라는 커피 두 잔 값으로 똑똑한 리뷰 매니저를 고용해 보세요.
          </p>
          <a href={APPLY_URL} target="_blank" rel="noreferrer" className={styles.btnApply}>
            프로모션 신청하기
          </a>
        </div>
      </div>

      {/* 푸터 */}
      <footer className={styles.footer}>
        <p>
          <strong>“지역소상공인”과 함께하는 (주)에스피지이</strong>
        </p>
        <p>서울시 강서구 마곡중앙로 161-8, C동 507호 (마곡동, 두산더랜드파크)</p>
        <p>대표자명: 김용회 ㅣ 사업자번호: 383-87-01230 ㅣ 고객센터: 050-7600-9999</p>
        <p style={{ marginTop: '15px' }}>Copyright © SPONGE 2026</p>
      </footer>

      {/* 카카오톡 상담 플로팅 버튼 */}
      <a href={KAKAO_URL} target="_blank" rel="noreferrer" className={styles.kakaoChatContainer} title="카카오톡 상담하기">
        <span className={styles.kakaoChatLabel}>카카오톡 상담하기</span>
        <div className={styles.kakaoChatBtn}>
          <svg className={styles.kakaoIcon} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 4c-7.732 0-14 4.938-14 11.032 0 3.947 2.628 7.406 6.55 9.38l-1.685 6.13c-.158.577.494 1.025.98.67l7.158-5.21c1.025.132 2.083.2 3.16.2 7.732 0 14-4.938 14-11.032S23.732 4 16 4z" />
          </svg>
        </div>
      </a>
    </div>
  )
}
